/* 中文词典：audio 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const audio = {
  // ---- 编解码器探测（probeCodecs）----
  'audio.codec.supportTitle': [ '浏览器音频编解码器支持' ],
  'audio.codec.supportGroup': [ { type: 'param', name: 'title' }, '（', { type: 'param', name: 'count' }, '/', { type: 'param', name: 'total' }, '）' ],
  'audio.codec.supportSummary': [ '<audio> / decodeAudioData 支持 ', { type: 'param', name: 'playable' }, '/', { type: 'param', name: 'total' }, ' 种' ],
  'audio.codec.tableFormat': [ '格式' ],
  'audio.codec.tableCodec': [ '编解码' ],
  'audio.codec.mp3WithCodecs': [ 'MP3 (带 codecs)' ],
  'audio.codec.rawLabel': [ '(裸) ', { type: 'param', name: 'mime' } ],

  // ---- BGM 引擎（BgmDirector）----
  'audio.bgm.disposed': [ '[BgmDirector] 已 dispose' ],
  'audio.bgm.ruleMissingCue': [ '[BgmDirector] 规则引用了不存在的 cue "', { type: 'param', name: 'cue' }, '"' ],
  'audio.bgm.defaultCueMissing': [ '[BgmDirector] defaultCue "', { type: 'param', name: 'cue' }, '" 不存在' ],
  'audio.bgm.initialCueMissing': [ '[BgmDirector] 解析出来的 cue "', { type: 'param', name: 'cue' }, '" 不存在' ],
  'audio.bgm.warmCueFailed': [ '[BgmDirector] 后台补齐 cue "', { type: 'param', name: 'cue' }, '" 失败：', { type: 'param', name: 'error' } ],
  'audio.bgm.preloadCueFailed': [ '[BgmDirector] 后台预加载 cue "', { type: 'param', name: 'cue' }, '" 失败：', { type: 'param', name: 'error' } ],
  'audio.bgm.trackDecodeFailed': [ '[BgmDirector] 音轨 "', { type: 'param', name: 'track' }, '" 的候选格式全部解码失败。\n  最常见的原因是**浏览器不支持这些编解码器** —— Linux 上的 Chromium / Brave / ungoogled-chromium 默认不带 AAC。\n  在控制台跑 logAudioCodecSupport() 看看浏览器到底支持什么。\n  试过的源：\n    · ', { type: 'param', name: 'failures' } ],
  'audio.bgm.trackMissing': [ '[BgmDirector] cue "', { type: 'param', name: 'cue' }, '" 引用了不存在的 track "', { type: 'param', name: 'track' }, '"' ],
  'audio.bgm.variantOverlayConflict': [ '[BgmDirector] cue "', { type: 'param', name: 'cue' }, '" 同时配了 variant 和 overlays，语义会打架' ],
  'audio.bgm.primaryTrackMissing': [ '[BgmDirector] cue "', { type: 'param', name: 'cue' }, '" 的 track 丢失' ],

  // ---- 热座（hotseat）----
  'audio.hotseat.configInvalid': [ '配置有问题，开不了局：', { type: 'param', name: 'problems' } ],
  'audio.hotseat.startFailed': [ '开局失败（', { type: 'param', name: 'action' }, '）：', { type: 'param', name: 'reason' } ],
  'audio.hotseat.event.playerJoined': [ { type: 'param', name: 'name' }, ' 加入' ],
  'audio.hotseat.event.playerLeft': [ { type: 'param', name: 'name' }, ' 离开' ],
  'audio.hotseat.event.readyChangedReady': [ { type: 'param', name: 'name' }, ' 已准备' ],
  'audio.hotseat.event.readyChangedUnready': [ { type: 'param', name: 'name' }, ' 取消准备' ],
  'audio.hotseat.event.configChanged': [ { type: 'param', name: 'name' }, ' 改了配置' ],
  'audio.hotseat.event.started': [ '开局！' ],
  'audio.hotseat.event.finished': [ '🏆 ', { type: 'param', name: 'name' }, ' 获胜！' ],
  'audio.hotseat.event.drawn': [ { type: 'param', name: 'name' }, ' 抽了 1 张' ],
  'audio.hotseat.event.played': [ { type: 'param', name: 'name' }, ' 打出 ', { type: 'param', name: 'cards' } ],
  'audio.hotseat.event.revealed': [ '亮出 ', { type: 'param', name: 'card' } ],
  'audio.hotseat.event.discarded': [ '弃掉 ', { type: 'param', name: 'cards' } ],
  'audio.hotseat.event.stolen': [ { type: 'param', name: 'name' }, ' 被抢走 1 张' ],
  'audio.hotseat.event.given': [ { type: 'param', name: 'from' }, ' 给了 ', { type: 'param', name: 'to' }, ' 1 张' ],
  'audio.hotseat.event.reclaimed': [ { type: 'param', name: 'name' }, ' 从弃牌堆捞回 ', { type: 'param', name: 'card' } ],
  'audio.hotseat.event.shuffled': [ '抽牌堆被洗乱' ],
  'audio.hotseat.event.peeked': [ { type: 'param', name: 'name' }, ' 偷看了牌堆顶 ', { type: 'param', name: 'n' }, ' 张' ],
  'audio.hotseat.event.lethalDrawn': [ { type: 'param', name: 'name' }, ' 抽到了 ', { type: 'param', name: 'card' }, '！' ],
  'audio.hotseat.event.lethalDefused': [ { type: 'param', name: 'name' }, ' 用救命牌化解了，并把它塞回牌堆' ],
  'audio.hotseat.event.lethalExploded': [ '💥 ', { type: 'param', name: 'name' }, ' 出局' ],
  'audio.hotseat.event.windowOpened': [ '响应窗口打开（', { type: 'param', name: 'name' }, ' 出的牌）' ],
  'audio.hotseat.event.windowNope': [ '🚫 ', { type: 'param', name: 'name' }, ' 打出 ', { type: 'param', name: 'card' }, ' 打断！' ],
  'audio.hotseat.event.windowClosedCancelled': [ '窗口关闭 —— 效果被取消' ],
  'audio.hotseat.event.windowClosedApplied': [ '窗口关闭 —— 效果生效' ],
  'audio.hotseat.event.turnStarted': [ '轮到 ', { type: 'param', name: 'name' }, '（剩 ', { type: 'param', name: 'n' }, ' 回合）' ],
  'audio.hotseat.event.turnEnded': [ { type: 'param', name: 'name' }, ' 回合结束' ],
  'audio.hotseat.event.turnAttacked': [ { type: 'param', name: 'name' }, ' 被要求连走 ', { type: 'param', name: 'n' }, ' 回合' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
audio satisfies Record<string, TextSpec>;
export default audio;
